<template>
  <div>
    <loading
      :active.sync="showLoader"
      :is-full-page="false"
      loader="bars"
    ></loading>

    <div
      v-bind:class="cardStyle"
      @resize='onResize'
    >

      <div>
        <div
          v-if="muzikDetails.isPinned"
          class="card-header bg-custom-featured text-dark"
        > <i
            v-if="!isSearchedMuzik"
            class="fa fa-star"
          ></i>
          {{muzikDetails.name}}
          <i
            v-on:click="copyMuzikUrl(muzikDetails.urlName)"
            class="fa fa-copy"
          ></i>
        </div>
        <div
          v-else
          class="card-header bg-dark text-white"
        >{{muzikDetails.name}}
          <i
            v-on:click="copyMuzikUrl(muzikDetails.urlName)"
            class="fa fa-copy"
          ></i>
          <i
            v-if="muzikDetails.facebookLink"
            v-on:click="openLinkInNewTab(muzikDetails.facebookLink)"
            class="fa fa-facebook-square mr-2"
          ></i>
        </div>

        <div class="card-body">
          <h5
            :title="muzikTitle"
            class="card-title "
            :class="muzikDetails.isPinned ? 'text-white' : 'text-white' "
          > {{!muzikDetails.isPinned && muzikTitle.length > 35 ? muzikTitle.slice(0,35)+" ...": muzikTitle}} </h5>
          <section class="h-100">

            <div class="d-flex align-items-center justify-content-center h-100">
              <div
                class="d-flex flex-column"
                v-bind:class="emitEffectCss"
              >
                <youtube
                  :video-id="muzikDetails.url"
                  :height="height"
                  :width="width"
                  ref="youtube"
                  @playing="onPlayerPlay"
                  @paused="onPlayerPause"
                  @ended="onPlayerEnded"
                  @ready="onPlayerReady"
                  :fitParent="true"
                ></youtube>

              </div>
            </div>

          </section>

        </div>
        <div
          class="card-footer"
          v-if="!muzikDetails.isPinned"
        >
          <button
            v-for="muzikTag in muzikDetails.tags"
            v-bind:key="muzikTag"
            v-on:click="tagFilter(muzikTag)"
            style="outline: none;"
            class="badge badge-pill mr-2 py-1"
            v-bind:class="(selectedMuzikTags && selectedMuzikTags.includes(muzikTag)) ? 'badge-success' : 'badge-dark'"
          ><span class="px-1">{{muzikTag}}
            </span><i class='fa fa-tag'></i></button>
        </div>
        <div
          class="card-footer text-white"
          v-else-if="muzikDetails.isPinned && muzikDetails.facebookLink"
          v-on:click="openLinkInNewTab(muzikDetails.facebookLink)"
        >Also available on <i class="fa fa-facebook-square"></i>acebook : <a
            class="bg-dark text-warning"
            style="cursor: pointer;"
          >{{muzikDetails.facebookLink}}</a>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "VideoPlayerEl",
  components: {
    Loading,
  },
  props: {
    isPinned: { type: Boolean, default: false },
    isSearchedMuzik: { type: Boolean, default: false },
    muzikDetails: Object,
    selectedMuzikTags: Array,
    autoPlayId: Number,
  },
  data() {
    return {
      showLoader: true,
      emitEffectCss: "",
      height: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? "280"
        : "360",
      width: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? "280"
        : "420",
      fitParent: true,
      cardStyle: "card text-white bg-secondary mt-3",
    };
  },
  mounted() {
    this.cardStyle = this.muzikDetails.isPinned
      ? "bg-custom-featured"
      : "bg-custom-2";
    this.cardStyle += " card text-white bg-secondary mt-3 ";

    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    this.$emit("onMuzikDestroy", this.$refs.youtube.player);
  },
  computed: {
    player() {
      return this.$refs.youtube.player;
    },
    muzikTitle: function () {
      let title = this.muzikDetails.featuring
        ? "Ft. " + this.muzikDetails.featuring
        : "";
      title += title && this.muzikDetails.movie ? " | " : "";
      title += this.muzikDetails.movie;

      if (this.muzikDetails.featuring !== this.muzikDetails.originalArtist)
        if (title) {
          title += " ( " + this.muzikDetails.originalArtist + " ) ";
        } else {
          title += this.muzikDetails.originalArtist;
        }
      return title;
    },
  },
  methods: {
    playVideo() {
      this.$refs.youtube.player.playVideo();
    },
    onResize(event) {
      this.showLoader = true;
      let outerWidth = event.target.outerWidth;

      if (outerWidth < 375) {
        this.width = 280;
        this.height = 280;
      } else if (outerWidth >= 375 && outerWidth < 425) {
        this.width = 320;
        this.height = 320;
      } else if (outerWidth >= 425 && outerWidth < 768) {
        this.width = 360;
        this.height = 360;
      } else if (outerWidth >= 768 && outerWidth < 991) {
        this.width = 720;
        this.height = 480;
      } else if (outerWidth >= 991 && outerWidth < 1200) {
        if (!this.muzikDetails.isPinned) {
          this.width = 440;
          this.height = 360;
        } else {
          this.width = 980;
          this.height = 480;
        }
        if (outerWidth > 1100 && !this.muzikDetails.isPinned) {
          this.width = 480;
        }
      } else if (outerWidth >= 1200) {
        if (!this.muzikDetails.isPinned) {
          this.width = 420;
          this.height = 360;
        } else {
          this.width = 980;
          this.height = 480;
        }
      } else {
        this.width = 400;
        this.height = 360;
      }

      this.showLoader = false;
    },
    openLinkInNewTab(url) {
      window.open(url, "_blank");
    },
    copyMuzikUrl(muzikCopy) {
      let _this = this;
      muzikCopy = "https://muzikdreamer.com?mzd=" + muzikCopy;
      this.$copyText(muzikCopy).then(
        function (e) {
          _this.$swal({
            // position: "top-end",
            icon: "success",
            title: "URL copied",
            showConfirmButton: false,
            timer: 1200,
          });
        },
        function (e) {
          _this.$swal({
            // position: "top-end",
            icon: "error",
            title: "URL could not be copied",
            showConfirmButton: false,
            timer: 1200,
          });
        }
      );
    },
    onPlayerReady(player) {
      let card = document.getElementsByClassName("card")[0];
      setTimeout(() => {
        this.showLoader = false;
        let currentWidth = card.clientWidth;
        var obj = new Object();
        obj.target = new Object();
        obj.target.outerWidth = card.clientWidth;
        this.onResize(obj);
      }, 1500);
    },
    tagFilter(muzikTag) {
      this.$emit("onMuzikTagSelect", muzikTag);
    },
    // listen event
    onPlayerPlay(player) {
      this.$emit("onMuzikPlay", player);
      this.emitEffectCss = "emit-effect-small";
    },
    onPlayerPause(player) {
      this.$emit("onMuzikPause", player);
      this.emitEffectCss = "";
    },
    onPlayerEnded(player) {
      this.$emit("onMuzikEnded", this.autoPlayId);
      this.emitEffectCss = "";
    },
  },
};
</script>

<style scoped>
.bg-custom-2 {
  /* background-image: linear-gradient(15deg, #53524f 20%, #f0f5f4 100%); */
  /* background-image: linear-gradient(15deg, #6dc557 0%, #23d8c3 100%) !important; */
  background-color: #d19592;
  background-image: linear-gradient(315deg, #d19592 0%, #c81f70 74%) !important;
}

.bg-custom-featured,
#test-block {
  color: white !important;
  background-color: #d4418e;
  background-image: linear-gradient(315deg, #d4418e 0%, #0652c5 74%);

  /* background-image: linear-gradient(15deg, #6dc557 0%, #23d8c3 100%) !important; */
}

.fa-copy {
  float: right;
  cursor: copy;
}

.card-header .fa-facebook-square {
  float: right;
  cursor: pointer;
}

.emit-effect-small {
  animation: 3s emit-small infinite forwards linear;
}

.emit-effect-big {
  animation: 3s emit-big infinite forwards linear;
}

@keyframes emit-big {
  0% {
    box-shadow: 0px 0px 0px 0px #000;
  }
  100% {
    box-shadow: 0px 0px 30px 40px rgba(255, 255, 255, 0.63);
  }
}

@keyframes emit-small {
  0% {
    box-shadow: 0px 0px 0px 0px #0ebe7b;
  }
  100% {
    box-shadow: 0px 0px 15px 20px rgba(255, 255, 255, 0.63);
  }
}
</style>